import store from '@/store'

export function authGuard(routes)
{
    return guard(routes, ( to, from, next ) => {
        store.dispatch('authCheck').then(res => {
            if (store.getters.authLoggedIn)
            {
                next()
            } else {
                next({name: 'login'})
            }
        }).catch(e => {
            next({name: 'login'})
        })
    })
}

export function guestGuard(routes)
{
    return guard(routes, (to, from, next) => {
        store.dispatch('authCheck').then(res => {
            if (store.getters.authLoggedIn)
            {
                next({name: 'welcome'})
            } else {
                next()
            }
        }).catch(e => {
            next()
        })
    })
}

function guard (routes, guard)
{
    routes.forEach(route => { route.beforeEnter = guard })

    return routes
}



// WEBPACK FOOTER //
// ./src/router/utils.js